export const roundNumber = (number, decimalPoints = 2) => {
    return (
        Math.round(number * Math.pow(10, decimalPoints)) /
        Math.pow(10, decimalPoints)
    );
};

export const getTextDigest = (text, maxLength = 80) => {
    return text.length > maxLength ? text.substr(0, maxLength) + " ..." : text;
};

export const normalizeFaNumbers = (number) => {
    const numberStr = number + "";
    const faNums = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
    const enNum = numberStr
        .split("")
        .map((item) =>
            faNums.findIndex((faNum) => faNum === item) >= 0
                ? faNums.findIndex((faNum) => faNum === item)
                : item
        )
        .join("");

    return enNum;
};

export const changeNumberLang = (str='', convertToLang = "fa") => {
    const persianNumbers = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
    const englishNumbers = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
    if (convertToLang === "fa") {
        englishNumbers.forEach((item, index) => {
            str = str.replace(new RegExp(item, "g"), persianNumbers[index]);
        });
    } else if (convertToLang === "en") {
        persianNumbers.forEach((item, index) => {
            str = str.replace(new RegExp(item, "g"), englishNumbers[index]);
        });
    }
    return str;
};

export const numberWithCommas = (x='') => {
    const number = changeNumberLang(x, "en");
    return number.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
